import React from 'react';
import { default as ReactSwitch } from 'react-switch';

type SwitchProps = {
  checked: boolean;
  label: string;
  onChange: () => void;
};

export const Switch: React.FC<SwitchProps> = ({ checked, onChange, label }) => {
  return (
    <label className="flex items-center gap-2">
      <span className="text-sm font-medium leading-[130%] text-sky dark:text-white-400">{label}</span>
      <ReactSwitch
        height={22}
        width={40}
        activeBoxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
        offColor={'#E5E7EB'}
        onColor={'#8DC641'}
        handleDiameter={18}
        onChange={onChange}
        checkedIcon={false}
        uncheckedIcon={false}
        checked={checked}
      />
    </label>
  );
};
